module.exports = __webpack_public_path__ + "static/media/TUSD_BUSD_Cake.4180cd61.png";